/**
 * @name clinica-mvp
 * @author Fellipe Orsini
 * @package clinica-mvp\app\assets\js\crud_agenda_hunter.js
 */

//import { apiCall, getBaseDir } from './utils.js';

var getBaseDir = null, apiCall = null, getPatientTypeDataByRole = null, getAgendaCategoryRoleByName = null;
var moment = require('moment-timezone');
const AgendaReschedule = require('./update_agenda_schedule.js');

$(function()
{
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getPatientTypeDataByRole = utils.getPatientTypeDataByRole;
        getAgendaCategoryRoleByName = utils.getAgendaCategoryRoleByName;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== getBaseDir() + 'agenda/hunter')
            return;

        new Dashboard(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class Dashboard
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.responses = {};
        this.filter = {
            'AGENDA_BUSINESS_BRANCH': -1,
            'AGENDA_DOCTOR': -1
        }

        this.calendar = null;
        this.updateModalDataObj = null;
        this.customerInsertWhatsappInput = null;
        this.customerEditWhatsappInput = null;
        this.isEditing = false;
        this.isInserting = false;
        this.EVENTS_LIST = [];
        this.FILTERED_EVENTS = [];

        if (onloadList) {
            this.getCurrentMonthAgenda();
        }

        let self = this;

        $(document).on('change', '.js-agenda-branches-selector', function() {
            let branchId = $(this).val();
            self.filter.AGENDA_BUSINESS_BRANCH = branchId;

            const selectElement = document.getElementsByClassName("js-agenda-branches-selector"); // Assuming you have a select element with the ID "mySelect"
            //selectElement[0].remove(0); // Remove the first option

            if (!self.calendar) {
                $('#calendar').html('');

                var currentDate = new Date(),
                    formattedDate = currentDate.toISOString().split('T')[0],
                    initialView = 'listDay', // agendaWeek / listWeek
                    toolBar = 'listDay, agendaWeek'; //agendaDay
                
                self.calendar = $('#calendar').fullCalendar({
                    lang: 'pt', // Set langage to french
                    schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                    locale: 'pt-br',
                    defaultView: initialView, // Set default view to week
                    headerToolbar: {
                        left: 'prev,next, listDay,agendaWeek',
                        center: 'title',
                        right: toolBar
                    },
                    defaultTimedEventDuration: '00:30:00',
                    forceEventDuration: true,
                    initialDate: formattedDate,
                    navLinks: false, // can click day/week names to navigate views
                    selectable: false,
                    selectMirror: true,
                    editable: false,
                    dayMaxEvents: true, // allow "more" link when too many events
                    updateSize: false,
                    allDaySlot: false, // Hide all day events
                    eventResizableFromStart: false,
                    eventLimit: false,
                    //daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Thursday
                    minTime: window._sessionData.businessMetaData.minAgendaHour,
                    maxTime: window._sessionData.businessMetaData.maxAgendaHour,
                    //hiddenDays: [ 7 ],
                    select: function(arg) {
                        $('#modal-create-event-hunter').modal('show');
                        let startHourAndMinutes = moment(arg.start).format('HH:mm').split(":"),
                            scheduleDate = moment(arg.start).format('YYYY-MM-DD');
                        if (!arg.allDay) {
                            $("#schedule_time_hour").val(startHourAndMinutes[0]);
                            $("#schedule_time_minutes").val(startHourAndMinutes[1]);
                        }
                        $("#schedule_date").val(scheduleDate);
                        self.calendar.unselect()
                    },
                    eventClick: function(arg) {
                        if (self.isEditing)
                            return;
                        
                        let findEvent = self.EVENTS_LIST.find((obj) => {
                            return parseInt(obj.id) == parseInt(arg.id);
                        });
                        if (!findEvent)
                            return;

                        if (findEvent.obj.CATEGORIA != getPatientTypeDataByRole('PACIENTE_NOVO')['DESCRICAO_AGENDA'] && getAgendaCategoryRoleByName(findEvent.obj.CATEGORIA) != 'AGENDADO' && getAgendaCategoryRoleByName(findEvent.obj.CATEGORIA) != 'CONFIRMADO') {
                            return window.toast({
                                error: true,
                                text: 'Você só pode editar horários "Vagos", "Agendados" e "Confirmado".'
                            })
                        }

                        let selectedStartDate = findEvent.obj.DATA_INICIO_FORMATED,
                            todayDate = moment().tz('America/Sao_Paulo'),
                            selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                            startHourMinute = findEvent.obj.HORA_INICIO_FORMATED.split(':'),
                            startDate = selectedStartDateMoment.set({
                                'hours': parseInt(startHourMinute), 
                                'minutes': parseInt(startHourMinute[1]), 
                                'seconds': 0
                            });

                        /*if (todayDate.unix() > startDate.unix()) {
                            return window.toast({
                                error: true,
                                text: 'Este horário já passou.'
                            })
                        }*/

                        self.updateModalDataObj = findEvent;

                        const dateInput = document.getElementById('hunter_agenda_edit_date'); // Get the date input element
                        const today = new Date().toISOString().split('T')[0]; // Get today's date
                        dateInput.setAttribute('min', today); // Set the minimum date to today

                        $('#modal-update-event-hunter').modal('show');
                        $('.js-update-event-hunter-dialog-title-id').html(findEvent.id);
                        $('#hunter_agenda_edit_business_branch').val(findEvent.obj.FILIAL_ID);
                        //$('#hunter_agenda_edit_business_branch').trigger('change');
                        $('#hunter_agenda_edit_doctor').val(self.updateModalDataObj.obj.DOUTORES_ID);
                        $('#hunter_agenda_edit_doctor').trigger('change');

                        $('#hunter_agenda_edit_date').val(self.updateModalDataObj.obj.DATA_INICIO_FORMATED);
                        $('#hunter_agenda_edit_date').trigger('change');
                        setTimeout(function() {
                            $(".modal-update-event-hunter-dialog").block(window._loader.loading);
                        }, 250);
                        self.isEditing = true;
                        self.agendaEditExistingCustomer = false;

                        if (findEvent.obj.CATEGORIA == 'Vago PN') {
                            $('.js-hunter-update-schedule-event-options').addClass('d-none');
                            $('.js-hunter-agenda-edit-submit-button').removeClass('d-none');
                            $('#hunter_agenda_edit_service').attr('readonly', false);
                            $('#hunter_agenda_edit_customer_origin').attr('readonly', false);
                            $('#hunter_agenda_edit_customer_name').attr('readonly', false);
                            $('#hunter_agenda_edit_customer_whatsapp').attr('readonly', false);
                        } else {
                            $('.js-hunter-update-schedule-event-options').removeClass('d-none');
                            $('.js-hunter-agenda-edit-submit-button').addClass('d-none');
                            $('#hunter_agenda_edit_service').attr('readonly', true);
                            $('#hunter_agenda_edit_customer_origin').attr('readonly', true);
                            $('#hunter_agenda_edit_customer_name').attr('readonly', true);
                            $('#hunter_agenda_edit_customer_whatsapp').attr('readonly', true);
                        }
                    },
                    eventResize: function(arg, element) {
                        let findEvent = self.EVENTS_LIST.filter((obj) => {
                            return parseInt(obj.id) === parseInt(arg.id);
                        });
                        if (!findEvent)
                            return;
                    },
                    eventDrop: function(arg, element) {
                        let findEvent = self.EVENTS_LIST.filter((obj) => {
                            return parseInt(obj.id) === parseInt(arg.id);
                        });
                        if (!findEvent)
                            return;
                    },
                    events: function(start, end, timezone, callback) {
                        let startStr = moment(start).tz("America/Sao_Paulo").format().split('T')[0];
                        let endStr = moment(end).tz("America/Sao_Paulo").format().split('T')[0];
                        
                        $("#calendar").block(window._loader.loading);

                        apiCall({
                            endpoint: 'api/v1/employee/agenda',
                            method: 'POST',
                            data: {
                                start: startStr,
                                end: endStr,
                                branchId: self.filter.AGENDA_BUSINESS_BRANCH,
                                doctorId: self.filter.AGENDA_DOCTOR,
                                isCalendar: 1
                            },
                            successCallback: function(res) {
                                console.log('[Calendar:events] crud_agenda_hunter.js/employee/agenda', res);
                                $("#calendar").unblock()
                                
                                if (!res.error) {
                                    self.EVENTS_LIST = res.data;
                                    console.log('self.EVENTS_LIST', self.EVENTS_LIST);
                                    callback(res.data);
                                }
                            },
                            errorCallback: function(res) {
                                $("#calendar").block(window._loader.error);
                                callback([]);
                            }
                        });
                    },
                    eventRender: function(eventObj, $el) {
                        //console.log('eventRender', eventObj, $el);
                        var event = eventObj;
                        var customHtml = $el.innerHTML;
                        const startHour = event.start.format('HH:mm');
                        const endHour = event.end.format('HH:mm');

                        const element = document.getElementsByClassName('js-business-doctors-selector');
                        const optionNames = [...element[0].options].map(o=>o.text);
                        let array = {};
                        for(let i in element[0].options) {
                            array[element[0].options[i].value] = element[0].options[i].text;
                        }

                        if (array[event.obj.DOUTORES_ID]) {
                            customHtml += `
                                <td class="fc-list-item-time fc-widget-content">${startHour} - ${endHour}</td>
                                <td class="fc-list-item-marker fc-widget-content"><span class="fc-event-dot" style="background-color:${event.color}"></span></td>
                                <td class="fc-list-item-time fc-widget-content"><button class="btn" style="background-color:${event.color}; color:#FFF;">${event.extendedProps.category}</button></td>
                                <td class="fc-list-item-title fc-widget-content"><a>Doutor(a) ${array[event.obj.DOUTORES_ID]}</a></td>
                                <td class="fc-list-item-title fc-widget-content"><a>${event.title}</a></td>
                            `;
                            $el.html(customHtml);
                        } else {
                            $el.html('');
                        }
                    }
                });
            } else {
                $("#calendar").block(window._loader.loading);
                $('#calendar').fullCalendar('refetchEvents')
            }
        });

        $(document).on('change', '.js-agenda-doctors-selector', function() {
            let doctorId = $(this).val();
            self.filter.AGENDA_DOCTOR = doctorId;
            $("#calendar").block(window._loader.loading);
            $('#calendar').fullCalendar('refetchEvents')
        });
    }

    getCurrentMonthAgenda() {
        let self = this;
        var initiated = false;
        function OnBusinessReady() {
            if (initiated)
                return;
            initiated = true;
            $(document).ready(function() {
                self.customerInsertWhatsappInput = window.intlTelInput(document.querySelector('input[id="hunter_agenda_insert_customer_whatsapp"]'), {
                    initialCountry: "br",
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });
                self.customerEditWhatsappInput = window.intlTelInput(document.querySelector('input[id="hunter_agenda_edit_customer_whatsapp"]'), {
                    initialCountry: "br",
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
                });
              
                self.bindAgendaInsertProcess();
                self.bindAgendaUpdateProcess();
            });

            $('#calendar').html('<br /><center><h3>Por favor filtre por filial para visualizar a agenda.</h3></center>');
            return;
        };
        window.businessReadyFunctions.push(OnBusinessReady);
    }
    
    bindAgendaInsertProcess() {
        let self = this;

        // Váriavel de estado da inserção de agendamentos
        this.agendaInsertData = {
            step: 0
        }
        this.agendaInsertExistingCustomer = false;

        // Detecta usuário clicando no botão "Novo agendamento"
        $(document).on('click', '.js-agenda-create-event', function() {
            if (self.isInserting)
                return;
            self.isInserting = true;
            self.agendaInsertExistingCustomer = false;

            const dateInput = document.getElementById('hunter_agenda_insert_date'); // Get the date input element
            const today = new Date().toISOString().split('T')[0]; // Get today's date
            dateInput.setAttribute('min', today); // Set the minimum date to today
            
            if (window._sessionData.isHunter) {
                //$('#hunter_agenda_insert_search_customer').prop('disabled', true);
                // Caso não seja paciente, pula para passo de seleção da filial e doutor
                hideCurrentAgendaInsertStep(); // Esconde passo anterior
                self.agendaInsertData.step = 2; // Configura passo atual para selecionar filial/doutor
                unhideCurrentAgendaInsertStep(); // Mostra passo atual
            }

            if (self.filter.AGENDA_BUSINESS_BRANCH != -1) {
                $('#hunter_agenda_insert_business_branch').val(self.filter.AGENDA_BUSINESS_BRANCH);
                //$('#hunter_agenda_insert_business_branch').trigger('change');
            }

            if (self.calendar) {
                let dateObj = new Date($('#calendar').fullCalendar('getDate')._d);
                let month = dateObj.getUTCMonth() + 1; //months from 1-12
                let day = dateObj.getUTCDate();
                let year = dateObj.getUTCFullYear();
                console.log('${year}-${month}-${day}', `${year}-${month}-${day}`);

                $('#hunter_agenda_insert_date').val(`${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`);
                $('#hunter_agenda_insert_date').trigger('change');
            }
        });

        // Inicia livraria select2 usado para busca de pacientes durante criação de agendamento
        $('#hunter_agenda_insert_search_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            dropdownParent: $("#modal-create-event-hunter"),
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function(params) {
                    var query = {
                        search: params.term,
                        branchId: $('#hunter_agenda_insert_business_branch').val() || -1,
                        page: params.page || 1
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function(k, v) {
                        results.push({
                            id: v.ID,
                            text: v.TEXT,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        // Detecta usuário buscando por paciente
        $('#hunter_agenda_insert_search_customer').on('select2:select', function(e) {
            $('#hunter_agenda_insert_customer_name').val(e.params.data.text);
            $('#hunter_agenda_insert_customer_whatsapp').val(e.params.data.info.FONE_CELULAR);

            self.agendaInsertExistingCustomer = e.params.data.info.ID; // Configura agendamento atual em um paciente já existent
            self.agendaInsertData.step = 2; // Configura passo atual para buscar paciente
            unhideCurrentAgendaInsertStep(); // Mostra passo atual
        });

        // Detecta usuário selecionando a Filial
        $(document).on('change', '#hunter_agenda_insert_business_branch', function() {
            let currentBranchValue = $(this).val();
            // Caso não tenha selecionado uma filial
            if (currentBranchValue == '') {
                hideCurrentAgendaInsertStep(); // Esconde passo anterior
                self.agendaInsertData.step = 2; // Configura passo atual para selecionar filial/doutor
                //$('#hunter_agenda_insert_date').prop('disabled', true);  // Desativa campo do "Doutor"
            } else {
                // Caso tenha selecionado uma filial
                // Desativa campo "Filial" e ativa "Data"
                //$('#hunter_agenda_insert_business_branch').prop('disabled', true);
                $('#hunter_agenda_insert_date').prop('disabled', false);

                // Caso troque de filial e tenha um doutor selecionado, esconde passos antigos e configura passo atual
                let currentDoctorValue = $('#hunter_agenda_insert_date').val();
                if (currentDoctorValue != '') {
                    hideCurrentAgendaInsertStep();
                    self.agendaInsertData.step = 2;
                }
            }
        });

        // Detecta usuário selecionando o Doutor
        /*$(document).on('change', '#hunter_agenda_insert_doctor', function() {
            let currentDoctorValue = $(this).val();
            // Caso não tenha selecionado um Doutor
            if (currentDoctorValue == '') {
                hideCurrentAgendaInsertStep(); // Esconde passo anterior
                self.agendaInsertData.step = 2; // Configura passo atual para selecionar filial/doutor
                unhideCurrentAgendaInsertStep(); // Mostr apasso atual
            } else {
                // Caso tenha selecionado um Doutor
                self.agendaInsertData.step = 3; // Configura passo atual para selecionar data e horário
                unhideCurrentAgendaInsertStep(); // Mostra passo atual

                $('#hunter_agenda_insert_start_hour').prop('disabled', true); 
                // Desabilita botão de seleção de horário
                $('#hunter_agenda_insert_start_hour').html(''); // Remove horários disponíveis do Doutor
                $('#hunter_agenda_insert_start_hour').val(''); // Remove valor do horário selecionado
                $('#hunter_agenda_insert_start_hour').trigger('change'); // Gatilho de "mudança" no campo de seleção de horário
                $('#hunter_agenda_insert_doctor').prop('disabled', false); // Desabilita campo do "Doutor"

                // Caso possua uma data de consulta configurada
                // realiza busca pelos horários edisponíveis
                let currentDate = $('#hunter_agenda_insert_date').val();
                if (currentDate != '') {
                    $('#hunter_agenda_insert_date').trigger('input');
                } else {
                    
                }
            }
        });*/

        // Detecta usuário selecionando a Data
        $(document).on('change', '#hunter_agenda_insert_date', function() {
            let currentBranchValue = $('#hunter_agenda_insert_business_branch').val();
            let currentAgendaInsertDate = $(this).val();

            if (currentBranchValue == '')
                return;

            // Verifica se o campo de Doutor está com um Doutor selecionado
            if ($("#hunter_agenda_insert_business_branch").val() === '') {
                hideCurrentAgendaInsertStep();
                self.agendaInsertData.step = 2;
                return;
            }

            // Caso tenha selecionado um Doutor
            self.agendaInsertData.step = 3; // Configura passo atual para selecionar data e horário
            unhideCurrentAgendaInsertStep(); // Mostra passo atual

            $(".modal-create-event-hunter-dialog").block(window._loader.loading);

            // Resgata horários disponíveis do Doutor
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/employee/agenda',
                data: {
                    branchId: parseInt($("#hunter_agenda_insert_business_branch option:selected").val().trim()),
                    date: currentAgendaInsertDate,
                    isCalendar: false
                },
                successCallback: function(res) {
                    console.log('crud_agenda_hunter.js/employee/agenda', '#hunter_agenda_insert_date', res);

                    if (res.error) {

                    } else {
                        // Configura horários disponíveis
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for(let i in res.data) {
                            let avaiDoctorHour = res.data[i];

                            if (!avaiDoctorHour.HORA_INICIO_FORMATED) {
                                console.error('[crud_agenda_hunter:edit] avaiDoctorHour', avaiDoctorHour);
                                continue;
                            }

                            let 
                                selectedStartDate = $('#hunter_agenda_insert_date').val(),
                                todayDate = moment().tz('America/Sao_Paulo'),
                                selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                                startHourMinute = avaiDoctorHour.HORA_INICIO_FORMATED.split(':'),
                                startDate = selectedStartDateMoment.set({'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0}),
                                isDisabled = false;

                            if (selectedStartDateMoment.format('YYYY-MM-DD') == todayDate.format('YYYY-MM-DD') && 
                                todayDate.unix() > startDate.unix()) {
                                    isDisabled = true;
                            }

                            html += `
                                <option value="${avaiDoctorHour.HORA_INICIO_FORMATED}" data-agenda-id="${avaiDoctorHour.ID}" data-doutor-id="${avaiDoctorHour.DOUTORES_ID}" ${isDisabled ? 'disabled' : ''}>${avaiDoctorHour.HORA_INICIO_FORMATED}</option>
                            `;
                        }
                        $('#hunter_agenda_insert_start_hour').prop('disabled', false);
                        $('#hunter_agenda_insert_start_hour').html(html);

                        $(".modal-create-event-hunter-dialog").unblock();
                    }
                },
                errorCallback(err) {
                    $(".modal-create-event-hunter-dialog").block(window._loader.error);
                    console.error('ERROR', 'crud_agenda_hunter.js/employee/agenda', '#hunter_agenda_insert_date', err);
                }
            });
        });

        // Detecta usuário selecionando horário, libera seleção de serviços
        $(document).on('change', '#hunter_agenda_insert_start_hour', function() {
            let selectedStartHour = $(this).val(),
                scheduleSelectedAgendaId = $('#hunter_agenda_insert_start_hour option:selected').data('agenda-id'),
                scheduleSelectedDoutorId = $('#hunter_agenda_insert_start_hour option:selected').data('doutor-id');

            // Caso o horário selecionado seja válido, carrega lista de serviços
            if (selectedStartHour != '') {
                $('#hunter_agenda_insert_service').prop('disabled', false);
                $('#hunter_agenda_insert_doctor').val(scheduleSelectedDoutorId);
                apiCall({
                    method: 'GET',
                    endpoint: 'api/v1/employee/services',
                    successCallback: function(res) {
                        console.log('crud_agenda_hunter.js/employee/services', '#hunter_agenda_insert_start_hour', res);
    
                        if (res.error) {
                            
                        } else {
                            let html = '<option selected default value="">-- Selecione --</option>';
                            for(let i in res.data) {
                                let serviceObj = res.data[i];
                                html += `
                                    <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}">${serviceObj.SERVICO}</option>
                                `;
                            }
                            $('#hunter_agenda_insert_service').prop('disabled', false);
                            $('#hunter_agenda_insert_service').html(html);
                        }
                    },
                    errorCallback(err) {
                        console.error('ERROR', 'crud_agenda_hunter.js/employee/services', '#hunter_agenda_insert_start_hour', err);
                    }
                });
            } else {
                $('#hunter_agenda_insert_service').prop('disabled', true);
                $('#hunter_agenda_insert_end_hour').val('');
            }
        });

        // Detecta usuário selecionando tipo de serviço
        $(document).on('change', '#hunter_agenda_insert_service', function() {
            let serviceName = $(this).val(),
                serviceNameMinimumTime = $('#hunter_agenda_insert_service option:selected').data('service-time'),
                selectedStartDate = $('#hunter_agenda_insert_date').val(),
                selectedStartHour = $('#hunter_agenda_insert_start_hour option:selected').val().trim();
            
            // Caso seja um tipo de serviço válido, cálcula tempo de término
            // e mostra botão de inserção
            if (serviceName != '') {
                let 
                    todayDate = moment().tz('America/Sao_Paulo'),
                    selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                    startHourMinute = selectedStartHour.split(':'),
                    startDate = selectedStartDateMoment.set({'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0});

                if (selectedStartDateMoment.format('YYYY-MM-DD') == todayDate.format('YYYY-MM-DD') && 
                    todayDate.unix() > selectedStartDateMoment.unix()) {
                    return window.toast({
                        error: true,
                        text: 'A data e horário selecionado estão no passado.'
                    });
                }

                $('#hunter_agenda_insert_end_hour').val(startDate.add('minutes', serviceNameMinimumTime).format('HH:mm'))

                self.agendaInsertData.step = 4;
                unhideCurrentAgendaInsertStep();
            } else {
                $('#hunter_agenda_insert_end_hour').val('');
                // Caso não tenha selecionado um serviço válido
                // esconde botão de inserção
                hideCurrentAgendaInsertStep();
                self.agendaInsertData.step = 3;
                unhideCurrentAgendaInsertStep();
            }
        });

        // Detecta usuário clicando para "Agendar"
        $(document).on('submit', '.js-hunter-business-scheduler', function(e) {
            e.preventDefault();
            let data = $(this).serializeArray(),
                scheduleSelectedAgendaId = $('#hunter_agenda_insert_start_hour option:selected').data('agenda-id');
            console.log('create-event data', data);

            data.push({
                name: 'hunter_agenda_insert_schedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            data.push({
                name: 'hunter_agenda_insert_customer_whatsapp_int',
                value: self.customerInsertWhatsappInput.getNumber()
            });
            data.push({
                name: 'hunter_agenda_insert_patient_type',
                value: 'PN'
            });
            if (self.agendaInsertExistingCustomer) {
                data.push({
                    name: 'hunter_agenda_insert_existing_customer',
                    value: self.agendaInsertExistingCustomer
                });
            }

            let selfForm = this;

            $(".modal-create-event-hunter-dialog").block(window._loader.loading);
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/doctor/agenda/create',
                data,
                successCallback: function(res) {
                    console.log('crud_agenda_hunter.js/doctor/agenda/create', '.js-hunter-business-scheduler', res);
                    $(".modal-create-event-hunter-dialog").unblock();

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $(selfForm).trigger('reset');
                        $('.js-create-event-hunter-dialog-close').trigger('click');
                        $("#calendar").block(window._loader.loading);
                        $('#calendar').fullCalendar('refetchEvents')
                    }
                },
                errorCallback: function(err) {
                    $(".modal-create-event-hunter-dialog").unblock();
                    //$(".modal-create-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_agenda_hunter.js/doctor/agenda/create', '.js-hunter-business-scheduler', err);
                }
            })
        });

        // Detecta fechamento do modal de criação de agendamento
        $("#modal-create-event-hunter").on("hidden.bs.modal", function () {
            // put your default event here
            if (self.isInserting) {
                self.isInserting =false;
                self.agendaInsertExistingCustomer = false;

                $(".modal-create-event-hunter-dialog").unblock();

                $('.js-hunter-business-scheduler').trigger('reset');

                $('#hunter_agenda_insert_search_customer').val('');
                $('#hunter_agenda_insert_search_customer').empty();

                //$('#hunter_agenda_insert_doctor').prop('disabled', true);
                $('#hunter_agenda_insert_doctor').val('');

                //$('#hunter_agenda_insert_date').prop('disabled', true);
                $('#hunter_agenda_insert_date').val('');

                $('#hunter_agenda_insert_start_hour').prop('disabled', true);
                $('#hunter_agenda_insert_start_hour').val('');

                $('#hunter_agenda_insert_end_hour').val('');

                $('#hunter_agenda_insert_service').prop('disabled', true);
                $('#hunter_agenda_insert_service').val('');

                $('#hunter_agenda_insert_customer_name').val('');
                $('#hunter_agenda_insert_customer_whatsapp').val('');

                self.agendaInsertData.step = 0;
                hideAllStepsButCurrentAgendaInsertStep();
                self.agendaInsertData.step = 2;
                unhideCurrentAgendaInsertStep();
            }
        });

        // Funções
        // Função responsável por mostrar o passo atual da criação do agendamento
        // Deve ser chamada após configurar o passo atual da criação do agendamento (this.agendaInsertData.step=X)
        function unhideCurrentAgendaInsertStep() {
            $('.agenda-step').each(function() {
                let step = $(this).data('agenda-step');
                if (step == self.agendaInsertData.step) {
                    $(this).removeClass('d-none');
                }
            });
        }

        // Função responsável por esconder o passo atual da criação de agendamento
        function hideCurrentAgendaInsertStep() {
            $('.agenda-step').each(function() {
                let step = $(this).data('agenda-step');
                if (step == self.agendaInsertData.step) {
                    $(this).addClass('d-none');
                }
            });
        }

        // Função responsável por esconder todos os passos da criação de um novo agendamento, menos o passo atual
        function hideAllStepsButCurrentAgendaInsertStep() {
            $('.agenda-step').each(function() {
                let step = $(this).data('agenda-step');
                if (step != self.agendaInsertData.step) {
                    $(this).addClass('d-none');
                }
            });
        }
    }

    bindAgendaUpdateProcess() {
        let self = this;

        this.agendaUpdateExistingCustomer = false;

        // Função chamada ao carregar lista de doutores
        /*function OnDoctorsReady() {
            if (self.isEditing) {
                $('#hunter_agenda_edit_doctor').val(self.updateModalDataObj.obj.DOUTORES_ID);
                $('#hunter_agenda_edit_doctor').trigger('change');

                $('#hunter_agenda_edit_date').val(self.updateModalDataObj.obj.DATA_INICIO_FORMATED);
                $('#hunter_agenda_edit_date').trigger('change');
            }
        }
        window.doctorsReadyFunctions.push(OnDoctorsReady); // Adiciona função "OnDoctorsReady" para lista de instâncias que devem ser chamadas ao carregar lista de doutores*/

        // Inicia livraria select2 usado para busca de pacientes durante criação de agendamento
        /*$('#hunter_agenda_edit_search_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            dropdownParent: $("#modal-update-event-hunter"),
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function(params) {
                    var query = {
                        search: params.term,
                        branchId: $('#hunter_agenda_edit_business_branch').val() || -1,
                        page: params.page || 1
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function(k, v) {
                        results.push({
                            id: v.ID,
                            text: v.TEXT,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        // Detecta usuário buscando por paciente
        $('#hunter_agenda_edit_search_customer').on('select2:select', function(e) {
            $('#hunter_agenda_edit_customer_name').val(e.params.data.text);
            $('#hunter_agenda_edit_customer_whatsapp').val(e.params.data.info.FONE_CELULAR);

            self.agendaEditExistingCustomer = e.params.data.info.ID; // Configura agendamento atual em um paciente já existente
        });*/

        // Detecta usuário selecionando a Filial
        $(document).on('change', '#hunter_agenda_edit_business_branch', function() {
            let currentBranchValue = $(this).val();
            // Caso não tenha selecionado uma filial
            if (currentBranchValue == '') {
                $('#hunter_agenda_edit_doctor').prop('disabled', true);  // Desativa campo do "Doutor"
            } else {
                // Caso tenha selecionado uma filial
                // Desativa campo "Filial" e ativa "Doutor"
                //$('#hunter_agenda_edit_business_branch').prop('disabled', true);
                $('#hunter_agenda_edit_doctor').prop('disabled', false);

                // Caso troque de filial e tenha um doutor selecionado, esconde passos antigos e configura passo atual
                let currentDoctorValue = $('#hunter_agenda_edit_doctor').val();
            }
        });

        // Detecta usuário selecionando o Doutor
        $(document).on('change', '#hunter_agenda_edit_doctor', function() {
            let currentDoctorValue = $(this).val();
            // Caso não tenha selecionado um Doutor
            if (currentDoctorValue == '') {
                $('#hunter_agenda_edit_doctor').prop('disabled', true);
            } else {
                
                // Caso possua uma data de consulta configurada
                // realiza busca pelos horários edisponíveis
                let currentDate = $('#hunter_agenda_edit_date').val();
                if (currentDate != '') {
                    //$('#hunter_agenda_edit_date').trigger('change');
                }
            }
        });

        // Detecta usuário selecionando a Data
        $(document).on('change', '#hunter_agenda_edit_date', function() {
            let currentAgendaEditDate = $(this).val();

            // Verifica se o campo de Doutor está com um Doutor selecionado
            if ($("#hunter_agenda_edit_doctor").val() === '') {
                $('#hunter_agenda_edit_doctor').prop('disabled', true);
                return;
            }

            // Resgata horários disponíveis do Doutor
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/doctor/agenda',
                data: {
                    doctorId: parseInt($("#hunter_agenda_edit_doctor option:selected").val().trim()),
                    branchId: parseInt($("#hunter_agenda_edit_business_branch option:selected").val().trim()),
                    date: currentAgendaEditDate,
                    full_agenda: 1
                },
                successCallback: function(res) {
                    console.log('crud_agenda_hunter.js/doctor/agenda', '#hunter_agenda_edit_date', res);

                    $(".modal-update-event-hunter-dialog").unblock()

                    if (res.error) {

                    } else {
                        // Configura horários disponíveis
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for(let i in res.data) {
                            let avaiDoctorHour = res.data[i];

                            if (!avaiDoctorHour.HORA_INICIO_FORMATED) {
                                console.error('[crud_agenda_hunter:edit] avaiDoctorHour', avaiDoctorHour);
                                continue;
                            }

                            let 
                                selectedStartDate = $('#hunter_agenda_edit_date').val(),
                                todayDate = moment().tz('America/Sao_Paulo'),
                                selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                                startHourMinute = avaiDoctorHour.HORA_INICIO_FORMATED.split(':'),
                                startDate = selectedStartDateMoment.set({'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0}),
                                isDisabled = false;

                            if (selectedStartDateMoment.format('YYYY-MM-DD') == todayDate.format('YYYY-MM-DD') && 
                                todayDate.unix() > startDate.unix()) {
                                    isDisabled = true;
                            }

                            html += `
                                <option value="${avaiDoctorHour.HORA_INICIO_FORMATED}" data-agenda-id="${avaiDoctorHour.ID}" ${self.updateModalDataObj?.obj?.ID == avaiDoctorHour.ID ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}>
                                    ${avaiDoctorHour.CATEGORIA} | ${avaiDoctorHour.HORA_INICIO_FORMATED}
                                </option>
                            `;
                        }
                        $('#hunter_agenda_edit_start_hour').prop('disabled', false);
                        $('#hunter_agenda_edit_start_hour').html(html);

                        $('#hunter_agenda_edit_service').prop('disabled', false);
                        apiCall({
                            method: 'GET',
                            endpoint: 'api/v1/employee/services',
                            data: { 'getAllServices': true },
                            successCallback: function(res) {
                                console.log('crud_agenda_hunter.js/employee/services', '#hunter_agenda_edit_date', res);
            
                                if (res.error) {
                                    
                                } else {
                                    let html = '<option selected default value="">-- Selecione --</option>';
                                    for(let i in res.data) {
                                        let serviceObj = res.data[i];
                                        html += `
                                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" ${
                                                serviceObj?.SERVICO?.toLowerCase().trim() == self.updateModalDataObj?.obj?.SERVICOS?.toLowerCase().trim() ? 'selected' : ''
                                            }>${serviceObj.SERVICO}</option>
                                        `;
                                    }
                                    $('#hunter_agenda_edit_service').prop('disabled', false);
                                    $('#hunter_agenda_edit_service').html(html);
                                    $('#hunter_agenda_edit_service').trigger('change');
                                }
                            },
                            errorCallback(err) {
                                console.error('ERROR', 'crud_agenda_hunter.js/employee/services', '#hunter_agenda_edit_date', err);
                            }
                        });
            
                        if (self.updateModalDataObj.obj.CLIENTE_DADOS) {
                            let dadosCliente = self.updateModalDataObj.obj.CLIENTE_DADOS.split("|");
                
                            if (dadosCliente.length > 0) {
                                if (dadosCliente[0].trim() != '')
                                    $('#hunter_agenda_edit_customer_name').val(dadosCliente[0]);
                                if (dadosCliente[1].trim() != '')
                                    self.customerEditWhatsappInput.setNumber(dadosCliente[1]);
                            }
                        }
                    }
                },
                errorCallback(err) {
                    $(".modal-update-event-hunter-dialog").unblock()
                    console.error('ERROR', 'crud_agenda_hunter.js/doctor/agenda', '#hunter_agenda_edit_date', err);
                }
            });

           
        });

        // Detecta usuário selecionando tipo de serviço
        $(document).on('change', '#hunter_agenda_edit_service', function() {
            let serviceName = $(this).val(),
                serviceNameMinimumTime = $('#hunter_agenda_edit_service option:selected').data('service-time'),
                selectedStartDate = $('#hunter_agenda_edit_date').val(),
                selectedStartHour = $('#hunter_agenda_edit_start_hour option:selected').val().trim();
            
            // Caso seja um tipo de serviço válido, cálcula tempo de término
            // e mostra botão de inserção
            if (serviceName != '') {
                let 
                    todayDate = moment().tz('America/Sao_Paulo'),
                    selectedStartDateMoment = moment(selectedStartDate).tz('America/Sao_Paulo'),
                    startHourMinute = selectedStartHour.split(':'),
                    startDate = selectedStartDateMoment.set({'hours': parseInt(startHourMinute[0]), 'minutes': parseInt(startHourMinute[1]), 'seconds': 0});

                $('#hunter_agenda_edit_end_hour').val(startDate.add('minutes', serviceNameMinimumTime).format('HH:mm'))
            } else {
                $('#hunter_agenda_edit_end_hour').val('');
            }
        });

        // Detecta usuário clicando em opção para "Reagendar" ou "Cancelar"
        $(document).on('click', '.js-hunter-update-schedule-event', function() {
            //return window.toast({error: false, text: 'Paciência é uma virtude.'});
            let eventType = $(this).data("type");
            let data = $('.js-hunter-business-scheduler-update').serializeArray(),
                scheduleSelectedAgendaId = $('#hunter_agenda_edit_start_hour option:selected').data('agenda-id');

            data.push({
                name: 'hunter_agenda_edit_schedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            data.push({
                name: 'hunter_agenda_edit_customer_whatsapp_int',
                value: self.customerEditWhatsappInput.getNumber()
            });
            data.push({
                name: 'hunter_agenda_edit_patient_type',
                value: 'PN'
            });
            if (self.agendaEditExistingCustomer) {
                data.push({
                    name: 'hunter_agenda_edit_existing_customer',
                    value: self.agendaEditExistingCustomer
                });
            }

            switch(eventType) {
                case 'Confirmado': {
                    console.log('Marcar como confirmado', data);
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como Confirmado um agendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Confirmado' de um agendamento que já foi cancelado." });
                    if (window.confirm('Você tem certeza que desja marcar como Confirmado?')) {
                        $(".modal-update-event-hunter-dialog").block();
                        apiCall({
                            method: 'POST',
                            endpoint: 'api/v1/doctor/agenda/mark_as_confirmed',
                            data,
                            successCallback: function(res) {
                                console.log('crud_agenda_hunter.js/doctor/agenda/mark_as_confirmed', '.js-hunter-business-scheduler-update', res);
                                $(".modal-update-event-hunter-dialog").unblock();
            
                                if (res.error) {
                                    window.toast({
                                        error: true,
                                        text: res.message
                                    })
                                } else {
                                    window.toast({
                                        error: false,
                                        text: res.message
                                    })
                                    $('.js-update-event-hunter-dialog-close').trigger('click');
                                    $("#calendar").block(window._loader.loading);
                                    $('#calendar').fullCalendar('refetchEvents')
                                }
                            },
                            errorCallback: function(err) {
                                $(".modal-update-event-hunter-dialog").unblock();
                                //$(".modal-update-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                console.error('ERROR', 'crud_agenda_hunter.js/doctor/agenda/update', '.js-hunter-business-scheduler-update', err);
                            }
                        })
                    }
                    break;
                }
                case 'Reagendado': {
                    console.log('Clicando para regandar', data)
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar um Reagendamento que foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Reagendado' de um agendamento que já foi cancelado." });
                    self.agendaRescheduleCache = data;
                    $("#modal-agenda-reschedule").modal('show');
                    let reSchedulment = new AgendaReschedule(data, function(response) {
                        console.log('reschedule response', response);
                        if (response) {
                            $('.js-update-event-hunter-dialog-close').trigger('click');
                            $("#calendar").block(window._loader.loading);
                            $('#calendar').fullCalendar('refetchEvents')
                        }
                    });
                    break;
                }
                case 'Cancelado': {
                    console.log('Clicando para Cancelar', data)
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'NAO_COMPARECEU')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' um agendamento que já foi marcado como 'Não Compareceu'." });
                    if (getAgendaCategoryRoleByName(self.updateModalDataObj.obj.CATEGORIA) === 'CANCELADO')
                        return window.toast({ error: true, text: "Não é possível marcar como 'Não Compareceu' de um agendamento que já foi cancelado." });
                    if (window.confirm('Você tem certeza que desja marcar como Cancelado?')) {
                        $(".modal-update-event-hunter-dialog").block();
                        apiCall({
                            method: 'POST',
                            endpoint: 'api/v1/doctor/agenda/mark_as_cancelled',
                            data,
                            successCallback: function(res) {
                                console.log('crud_agenda_hunter.js/doctor/agenda/mark_as_cancelled', '.js-hunter-business-scheduler-update', res);
                                $(".modal-update-event-hunter-dialog").unblock();
            
                                if (res.error) {
                                    window.toast({
                                        error: true,
                                        text: res.message
                                    })
                                } else {
                                    window.toast({
                                        error: false,
                                        text: res.message
                                    })
                                    $('.js-update-event-hunter-dialog-close').trigger('click');
                                    $("#calendar").block(window._loader.loading);
                                    $('#calendar').fullCalendar('refetchEvents')
                                }
                            },
                            errorCallback: function(err) {
                                $(".modal-update-event-hunter-dialog").unblock();
                                //$(".modal-update-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                                console.error('ERROR', 'crud_agenda_hunter.js/doctor/agenda/mark_as_cancelled', '.js-hunter-business-scheduler-update', err);
                            }
                        })
                    }
                    break;
                }
            }
        });

        // Detecta usuário clicando para "Atualizar agendamento"
        $(document).on('submit', '.js-hunter-business-scheduler-update', function(e) {
            e.preventDefault();
            let data = $(this).serializeArray(),
                scheduleSelectedAgendaId = $('#hunter_agenda_edit_start_hour option:selected').data('agenda-id');
            console.log('update-event data', data);

            data.push({
                name: 'hunter_agenda_edit_schedule_agenda_id',
                value: scheduleSelectedAgendaId
            });
            data.push({
                name: 'hunter_agenda_edit_customer_whatsapp_int',
                value: self.customerEditWhatsappInput.getNumber()
            });
            data.push({
                name: 'hunter_agenda_edit_patient_type',
                value: 'PN'
            });
            if (self.agendaEditExistingCustomer) {
                data.push({
                    name: 'hunter_agenda_edit_existing_customer',
                    value: self.agendaEditExistingCustomer
                });
            }

            let selfForm = this;

            $(".modal-update-event-hunter-dialog").block(window._loader.loading);
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/doctor/agenda/update',
                data,
                successCallback: function(res) {
                    console.log('crud_agenda_hunter.js/doctor/agenda/update', '.js-hunter-business-scheduler-update', res);
                    $(".modal-update-event-hunter-dialog").unblock();

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $(selfForm).trigger('reset');
                        $('.js-update-event-hunter-dialog-close').trigger('click');
                        $("#calendar").block(window._loader.loading);
                        $('#calendar').fullCalendar('refetchEvents')
                    }
                },
                errorCallback: function(err) {
                    $(".modal-update-event-hunter-dialog").unblock();
                    //$(".modal-update-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_agenda_hunter.js/doctor/agenda/update', '.js-hunter-business-scheduler-update', err);
                }
            })
        });

        // Deteca fechamento da tela de edição de agendamento
        $("#modal-update-event-hunter").on("hidden.bs.modal", function () {
            // put your default event here
            if (self.isEditing) {
                self.isEditing = false;
                self.agendaEditExistingCustomer = false;
            }
        });
    }

    startReScheduleFlow() {

    }
}
